module.exports = __webpack_public_path__ + "Icono Disponibilidad512.png";